import type { ClientOverviewRepository } from "../repositories/ClientOverviewRepository";
import type { RevenueBootstrapEntity } from "../entities/RevenueBootstrapEntity";

export class GetRevenueBootstrapUseCase {
  constructor(private readonly repository: ClientOverviewRepository) {}

  async execute(): Promise<RevenueBootstrapEntity> {
    return this.repository.getRevenueBootstrap();
  }
}
